import { render, staticRenderFns } from "./MainSearch.vue?vue&type=template&id=85edaf28&scoped=true&"
import script from "./MainSearch.vue?vue&type=script&lang=js&"
export * from "./MainSearch.vue?vue&type=script&lang=js&"
import style0 from "./MainSearch.vue?vue&type=style&index=0&id=85edaf28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85edaf28",
  null
  
)

export default component.exports